import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { MEMBERSHIP_API } from 'modules/school/api/membership-api'
import type { CourseQuizId } from '../types/course-quiz-interface'

interface UseResetCourseQuizResult {
  resetCourseQuiz: (courseQuizId: number) => Promise<void>
  isFetching: boolean
}

export const useResetCourseQuiz = (): UseResetCourseQuizResult => {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation({
    method: RequestMethodsEnum.post,
  })
  return {
    resetCourseQuiz: async (courseQuizId: CourseQuizId) => {
      await fetcher(`${MEMBERSHIP_API}/quiz/${courseQuizId}/retake`)
    },
    isFetching,
  }
}
